/* Creative Velas — microinteracciones (sin dependencias) */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Revelado suave al entrar en pantalla */
  function reveal(root) {
    var items = (root || document).querySelectorAll('[data-cv-reveal]:not(.cv-in)');
    if (!('IntersectionObserver' in window) || reduce) {
      items.forEach(function (el) { el.classList.add('cv-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('cv-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* Parallax ligero del hero (solo escritorio, máx. ~40px) */
  var parallaxBound = false;
  function parallax() {
    var el = document.querySelector('[data-cv-parallax]');
    if (!el || parallaxBound || reduce || window.matchMedia('(max-width: 989px)').matches) return;
    parallaxBound = true;
    var ticking = false;
    function update() {
      var node = document.querySelector('[data-cv-parallax]');
      if (node) {
        var y = Math.min(window.scrollY, window.innerHeight);
        node.style.transform = 'translate3d(0,' + (y * 0.06).toFixed(1) + 'px,0)';
      }
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  }

  /* Valor elegido junto al nombre de la opción y precio de cada tamaño */
  var sizeData = null;
  function readSizeData() {
    var s = document.getElementById('cv-size-prices');
    if (!s) return;
    try { sizeData = JSON.parse(s.textContent); } catch (e) { sizeData = null; }
  }
  function decorateVariants() {
    document.querySelectorAll('variant-picker fieldset.variant-option').forEach(function (fs) {
      var legend = fs.querySelector('legend');
      var checked = fs.querySelector('input:checked');
      if (!legend || !checked) return;
      var span = legend.querySelector('.cv-legend-value');
      if (!span) { span = document.createElement('span'); span.className = 'cv-legend-value'; legend.appendChild(span); }
      if (span.textContent !== checked.value) span.textContent = checked.value;
      if (sizeData && sizeData.option && checked.name.indexOf(sizeData.option + '-') === 0) {
        fs.querySelectorAll('input').forEach(function (input) {
          var price = sizeData.prices[input.value];
          var label = input.closest('label');
          var text = label && label.querySelector('.variant-option__button-label__text');
          if (!price || !text || text.querySelector('.cv-pill-price')) return;
          var p = document.createElement('span'); p.className = 'cv-pill-price'; p.textContent = price;
          text.appendChild(p);
        });
      }
    });
  }

  /* Contador de caracteres de la frase personalizada */
  function personalization() {
    document.querySelectorAll('[data-cv-personal]').forEach(function (input) {
      if (input.dataset.cvBound) return;
      input.dataset.cvBound = '1';
      var out = document.getElementById(input.getAttribute('data-cv-count'));
      var max = parseInt(input.getAttribute('maxlength'), 10) || 0;
      function sync() { if (out) out.textContent = input.value.length + ' / ' + max; }
      input.addEventListener('input', sync); sync();
    });
  }

  /* Destello sutil en el botón cuando el producto se añade al carrito */
  document.addEventListener('cart:update', function () {
    var btn = document.querySelector('main[data-template^="product"] add-to-cart-component .button, main[data-template^="product"] .add-to-cart-button');
    if (!btn) return;
    btn.classList.remove('cv-added-flash'); void btn.offsetWidth; btn.classList.add('cv-added-flash');
  });

  var pending = null;
  function refresh() {
    if (pending) return;
    pending = window.setTimeout(function () { pending = null; decorateVariants(); personalization(); }, 80);
  }

  function init() {
    reveal(); parallax(); readSizeData(); decorateVariants(); personalization();
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-picker')) refresh();
    });
    document.addEventListener('variant:update', refresh);
    var picker = document.querySelector('main[data-template^="product"] .product-details');
    if (window.MutationObserver && picker) {
      new MutationObserver(function (list) {
        for (var i = 0; i < list.length; i++) {
          var t = list[i].target;
          if (t.nodeType === 1 && t.closest && t.closest('.cv-legend-value, .cv-pill-price')) continue;
          refresh(); return;
        }
      }).observe(picker, { childList: true, subtree: true });
    }
    document.addEventListener('shopify:section:load', function (e) { reveal(e.target); parallax(); readSizeData(); refresh(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();